import { Divider, Typography } from '@mui/material';
import { usePreferredLanguage } from '../../../services/entities/hooks/settings/usePreferredLanguage';
import { usePreferredUnits } from '../../../services/entities/hooks/settings/usePreferredUnits';
import { defaultUserSettings } from '../../../services/entities/hooks/settings/useSettings';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { MenuPaper } from '../../commonUI/Menu/MenuPaper';
import { SettingsMenuRow } from '../components/SettingsMenuRow';
import { NativeLanguageSelectionDropdown } from './components/LanguageSelect';
import UnitSelectionDropdown from './components/UnitSelect';

export const GeneralSettings = () => {
  const { t } = useTranslation();

  const { preferredLanguage, setPreferredLanguage } = usePreferredLanguage();
  const { preferredUnits, setPreferredUnits } = usePreferredUnits();

  return (
    <MenuPaper>
      <SettingsMenuRow>
        <Typography>{t('Language')}</Typography>
        <NativeLanguageSelectionDropdown
          value={preferredLanguage ?? defaultUserSettings.language}
          onChange={setPreferredLanguage}
        />
      </SettingsMenuRow>
      <Divider />
      <SettingsMenuRow>
        <Typography>{t('Units of Measurements')}</Typography>
        <UnitSelectionDropdown
          value={preferredUnits ?? defaultUserSettings.units}
          onChange={setPreferredUnits}
        />
      </SettingsMenuRow>
    </MenuPaper>
  );
};
